import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  USER_USER_AGREEMENT_BEGIN,
  USER_USER_AGREEMENT_SUCCESS,
  USER_USER_AGREEMENT_FAILURE,
  USER_USER_AGREEMENT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';

export function userAgreement(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: USER_USER_AGREEMENT_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${config.apiRootUrl}/user-agreement/`,
        args,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: USER_USER_AGREEMENT_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: USER_USER_AGREEMENT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUserAgreementError() {
  return {
    type: USER_USER_AGREEMENT_DISMISS_ERROR,
  };
}

export function useUserAgreement() {
  const dispatch = useDispatch();

  const { userAgreementPending, userAgreementError } = useSelector(
    (state) => ({
      userAgreementPending: state.user.userAgreementPending,
      userAgreementError: state.user.userAgreementError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(userAgreement(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissUserAgreementError());
  }, [dispatch]);

  return {
    userAgreement: boundAction,
    userAgreementPending,
    userAgreementError,
    dismissUserAgreementError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_USER_AGREEMENT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        userAgreementPending: true,
        userAgreementError: null,
      };

    case USER_USER_AGREEMENT_SUCCESS:
      // The request is success
      return {
        ...state,
        userAgreementPending: false,
        userAgreementError: null,
      };

    case USER_USER_AGREEMENT_FAILURE:
      // The request is failed
      return {
        ...state,
        userAgreementPending: false,
        userAgreementError: action.data.error,
      };

    case USER_USER_AGREEMENT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        userAgreementError: null,
      };

    default:
      return state;
  }
}
